import type { BuilderElement } from '@/utils/builder/types';
import { WEB_SAFE_FONTS } from '@/constants/fonts';

// Collect all custom (non-web-safe) fonts used in elements
export const collectCustomFonts = (elements: BuilderElement[]): string[] => {
  const result = new Set<string>();
  const stripFallbacks = (font: string) =>
    font.split(',')[0].replace(/['"]/g, '').trim();

  const dfs = (els: BuilderElement[]) => {
    els.forEach((el) => {
      if (!el) return;

      const addFont = (fontFamily: string) => {
        if (
          !WEB_SAFE_FONTS.find(
            (f) => f.value.toLowerCase() === fontFamily.toLowerCase()
          )
        ) {
          result.add(stripFallbacks(fontFamily));
        }
      };

      if (el.styles?.fontFamily) addFont(el.styles.fontFamily);

      if (el.responsiveStyles) {
        Object.values(el.responsiveStyles).forEach(
          (style: { fontFamily?: string }) => {
            if (style.fontFamily) addFont(style.fontFamily);
          }
        );
      }

      if (el.children?.length) dfs(el.children);
    });
  };

  dfs(elements);
  return Array.from(result);
};
